import React, { useContext } from "react";
import { CartContext } from "./CartContext";
import axios from "axios";
import "../styles/ProductCard.css";
import { useNavigate } from "react-router-dom";
import useAgentId from "./useAgentId";
import { API_BASE_URL } from '../constants';
import { cartConfig } from '../utils/cartApi';



const ProductCard = ({ item, smallImage = false }) => {
  const { cart, setCart, incQuant, decQuant, triggerToast } = useContext(CartContext);
  const { getUrlWithAgentId } = useAgentId();

  const getSessionKey = () => {
    let sessionKey = localStorage.getItem('cart_session_key');
    if (!sessionKey) {
      sessionKey = `anon_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('cart_session_key', sessionKey);
    }
    return sessionKey;
  };

  const navigate = useNavigate();
  const handleClick = () => {
    navigate(getUrlWithAgentId(`/product/${item.id}`));
  };

  const isSoldOut = item.available === false;
  const handleCart = async () => {
    try {
      const payload = { item: item.id, quantity: 1 };
      const config = {
        headers: (await cartConfig()).headers
      };
      const res = await axios.post(`${API_BASE_URL}/cart/`, payload, config);
      setCart([...cart, res.data]);
      triggerToast(`${item.name} added to cart`);

    } catch (error) {
      console.log(error);
      alert("Couldn't add");
    }
  };

  const selectedPrice =
    item.price_quarter ??
    item.price_half ??
    item.price;

  const selectedDiscountedPrice =
    item.discounted_price_quarter ??
    item.discounted_price_half ??
    item.discounted_price;

  // convert to numbers
  const price = selectedPrice != null ? Number(selectedPrice) : null;
  const discounted = selectedDiscountedPrice != null ? Number(selectedDiscountedPrice) : null;

  const hasDiscount =
    typeof price === "number" &&
    typeof discounted === "number" &&
    discounted > 0 &&
    discounted < price;

  const discountPercent = hasDiscount
    ? Math.round(((price - discounted) / price) * 100)
    : 0;

  return (
    <div
      className={`bestseller-card ${isSoldOut ? "sold-out-card" : ""}`}
      onClick={!isSoldOut ? handleClick : undefined}
    >
      <div className="image-container">
        <img className="bestseller-img" src={item.image} alt={item.name} />
        {isSoldOut && (
          <div className="sold-out-overlay">
            SOLD OUT
          </div>
        )}
        {/* both badges sit in the top-left corner, so sold-out items show only SOLD OUT */}
        {item.bestseller && !isSoldOut && (
          <div className="bestseller-badge">
            🔥 Bestseller
          </div>
        )}

        {item.delivery_time === 0 && (
          <div className="instant-delivery-badge">
            ⚡ Instant Delivery
          </div>
        )}
        {item.total_reviews > 0 && (
          <div className="rating-badge">
            ⭐ {item.avg_rating}
          </div>
        )}

      </div>
      <div className="bestseller-info">
        <p className="card-name">{item.name}</p>
        <p className="card-price">
          {hasDiscount ? (
            <>
              <span className="card-original-price">Rs.{price}</span>
              <span className="card-discounted-price">Rs.{discounted}</span>
              <span className="card-discount-percent">
                ({discountPercent}% OFF)
              </span>
            </>
          ) : (
            <span className="card-normal-price">Rs.{price}</span>
          )}
        </p>
      </div>


    </div>
  );
};

export default ProductCard;